import styled from '@emotion/styled'

export const FullWidthButton = styled.button`
  width: 100%;
  height: 40px;
  background-color: #ff4a52;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: block;
  margin: 16px auto 0;
`
